"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var portalId = _hubspot.default.get();

var BLOG_POSTS_URI = 'blogs/v3/blog-posts';

var BlogPostsAPI =
/*#__PURE__*/
function () {
  function BlogPostsAPI() {
    (0, _classCallCheck2.default)(this, BlogPostsAPI);
  }

  (0, _createClass2.default)(BlogPostsAPI, null, [{
    key: "getBlogPosts",
    value: function getBlogPosts(contentGroupId) {
      return _apiClient.default.get(BLOG_POSTS_URI, {
        data: {
          archived: false,
          contentGroupId: contentGroupId,
          limit: 1,
          order: '-publihDate',
          portalId: portalId
        }
      });
    }
  }]);
  return BlogPostsAPI;
}();

exports.default = BlogPostsAPI;
module.exports = exports.default;